'use client';
import React, { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-md border-b border-primary/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-end justify-between pb-4 pt-10">
        {/* Left nav links */}
        <div className="hidden md:flex items-center gap-10">
          <a
            href="#pourquoi"
            onClick={(e) => handleNav(e, '#pourquoi')}
            className={`text-[10px] uppercase tracking-ultra font-medium hover-underline transition-colors duration-300 ${
              scrolled ? 'text-foreground-muted hover:text-foreground' : 'text-foreground/70 hover:text-foreground'
            }`}
          >
            Pourquoi
          </a>
          <a
            href="#livret"
            onClick={(e) => handleNav(e, '#livret')}
            className={`text-[10px] uppercase tracking-ultra font-medium hover-underline transition-colors duration-300 ${
              scrolled ? 'text-foreground-muted hover:text-foreground' : 'text-foreground/70 hover:text-foreground'
            }`}
          >
            Le Livret
          </a>
        </div>

        {/* Right CTA */}
        <div className="flex items-center gap-6">
          <a
            href="https://livretvacancesguadeloupe.fr/connexion"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden md:inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white text-[10px] uppercase tracking-wide-xl font-medium px-6 py-3 transition-all duration-300"
          >
            Activer gratuitement
          </a>
          {/* Mobile CTA */}
          <a
            href="https://livretvacancesguadeloupe.fr/connexion"
            target="_blank"
            rel="noopener noreferrer"
            className="md:hidden text-[10px] uppercase tracking-wide font-medium text-primary border border-primary/30 px-4 py-2"
          >
            Activer
          </a>
        </div>
      </div>
    </nav>
  );
}